import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Styles from "./index.module.scss";
import clsx from "clsx";
import useMDProfile, {
  ONE_MILLION_UNIT,
} from "../../../Hooks/useClientProfile";
import { ClientHistoryModalTable } from "../ClientHistoryModalTable";
import { useEffect, useMemo, useRef, useState } from "react";
import { formatNumber, formatProfileDay } from "../../../Utils";
import { RiMessengerLine } from "react-icons/ri";
import { Path } from "../../../Api/Path";

// Component: QR Code Section
const QRCodeSection = ({
  loading,
  error,
  qrCode,
  voucherText,
  qrUserId,
  handleSubmit,
  handleGenerateDefaultQR,
  voucher,
  example,
  handleAmountChange,
  amount,
  showNewVersion,
  handleChangeVersion,
  handleNormalAmountChange,
  qrNormalAmount,
  qrNormal,
  handleGenerateNormalQR,
  qrNormalError,
}) => {
  // Hàm định dạng đơn vị
  const formatUnit = (value, isShowCurrency = true, showUnit = true) => {
    let formattedValue;

    if (value / 1000 > 999) {
      formattedValue = formatNumber(value / 1000000);
      return showUnit
        ? `${formattedValue}${isShowCurrency ? "tr" : " tr"}`
        : formattedValue;
    } else {
      formattedValue = formatNumber(value / 1000);
      return showUnit ? `${formattedValue}k` : formattedValue;
    }
  };

  // Tạo chi tiết voucher với useMemo để tối ưu hiệu suất
  const voucherDetails = useMemo(() => {
    if (!example || !voucher) return null;

    const minPay = formatUnit(voucher.minPay * ONE_MILLION_UNIT, false);
    const minPayWithoutUnit = formatUnit(
      voucher.minPay * ONE_MILLION_UNIT,
      false,
      false
    );
    const limit1 = formatUnit(voucher.limit1 * ONE_MILLION_UNIT, false);
    const limit2 = formatUnit(voucher.limit2 * ONE_MILLION_UNIT, false);
    const firstKnbKhoa = example.first.knbKhoa;
    const firstMoney = formatUnit(example.first.money);
    const secondKnbKhoa = example.second.knbKhoa;
    const secondMoney = formatUnit(example.second.money);
    const refKnbKhoa = example.refKnbKhoa;

    return (
      <>
        <p>
          {`Tích lũy ${minPayWithoutUnit} đến ${limit1} đầu: ${firstKnbKhoa} KNB khuyến mãi/${firstMoney}`}
        </p>
        {example.second.money > 0 ? (
          <p>
            {`Tích lũy ${minPayWithoutUnit} đến ${limit2} tiếp theo: ${secondKnbKhoa} KNB khuyến mãi/${secondMoney}`}
          </p>
        ) : (
          <p>Từ 0 - 100k tiếp theo: 1KNB/100k</p>
        )}
        {refKnbKhoa > 0 && (
          <p>{`Thêm 100k - ID ${qrUserId} được tặng ${refKnbKhoa} KNB khuyến mãi`}</p>
        )}
        <p>{`Tối thiểu một lần thêm khuyến mãi: ${minPay}`}</p>
      </>
    );
  }, [example, voucher, qrUserId]);

  // Tách thành các component nhỏ hơn để dễ quản lý
  const renderLoadingState = () => (
    <div className={clsx(Styles.loading)}>
      <p>Đang xác minh . . .</p>
    </div>
  );

  const renderErrorState = () => (
    <div className={clsx(Styles.error)}>
      <p>Vui lòng kiểm tra lại ID hoặc để trống để tạo QR mặc định</p>
      <p>
        Bấm để
        <strong onClick={handleGenerateDefaultQR}>Tạo QR mặc định</strong>
      </p>
    </div>
  );

  const renderQRContent = () => (
    <>
      <p className={clsx(Styles.title)}>Thêm KNB KHUYẾN MÃI - NHẬN KNB khuyến mãi</p>
      <img src={qrCode} alt="QR Code" />
      <div className={clsx(Styles.qrTextBlock)}>
        <p className={clsx(Styles.qrInfor)}>
          QR với ID: {qrUserId} - Nhận KNB khuyến mãi
        </p>
        <div className={clsx(Styles.qrDetailCard)}>
          {voucherText && <p className={clsx(Styles.qrDetail)}>{voucherText}</p>}
          <p className={clsx(Styles.qrDetail)}>
            1 KNB khuyến mãi = 20 tiền đồng khuyến mãi
          </p>
          <p className={clsx(Styles.qrDetail)}>
            Trạng thái KNB/tiền đồng là khoá
          </p>
          <p className={clsx(Styles.qrDetail)}>
            Chỉ sử dụng được với chức năng xoay đồ xanh tại NPC thương nhân tây vực
          </p>
        </div>
        {voucher && (
          <div className={clsx(Styles.voucherDetail)}>
            {voucherDetails}
          </div>
        )}
      </div>
    </>
  );

  const renderInputForm = () => (
    <div
      className={clsx(Styles.inputVoucher)}
      style={{ margin: "20px auto 10px auto" }}
    >
      {!showNewVersion ? null : (
        <>
          <p style={{ textAlign: "left" }}>Bạn cần tạo QR với số tiền ?</p>
          <div className={clsx(Styles.inputRow, Styles.amountRow)}>
            <input
              id="amount"
              name="amount"
              type="text"
              placeholder="Nhập số tiền"
              value={amount.formatValue}
              onChange={handleAmountChange}
              className={clsx(Styles.amountInput)}
            />
            <button type="button" onClick={handleSubmit}>
              Tạo QR khuyến mãi
            </button>
          </div>
        </>
      )}

      {error && <span className={clsx(Styles.errorMessage)}>{error}</span>}
    </div>
  );

  const renderNormalQRSection = () => (
    <div className={clsx(Styles.qrCodeNormal)}>
      {loading && renderLoadingState()}
      {!loading && error && renderErrorState()}
      {!error && !loading && qrNormal && (
        <>
          <p className={clsx(Styles.title)}>Thêm KIM NGUYÊN BẢO - NHẬN KNB</p>
          <img src={qrNormal} alt="QR Code" className={clsx(Styles.qrCodeImg)} />
          <div className={clsx(Styles.qrTextBlock)}>
            <p className={clsx(Styles.qrInfor)}>
              QR với ID: {qrUserId} - Nhận KNB
            </p>
            <div className={clsx(Styles.qrDetailCard)}>
              <p className={clsx(Styles.qrDetail)}>
                Tỉ lệ: 100k nhận 1 KNB, tối thiểu 1 lần thêm là 100k
              </p>
              <p className={clsx(Styles.qrDetail)}>1 KNB = 20 tiền đồng (xu)</p>
              <p className={clsx(Styles.qrDetail)}>
                Hoặc 1 KNB = 60 Tiền đồng hoạt động, để trải nghiệm nhanh máy chủ,
                hạn sử dụng 2 tháng
              </p>
            </div>
          </div>
        </>
      )}

      <div
        className={clsx(Styles.inputVoucher)}
        style={{ margin: "20px auto 10px auto" }}
      >
        {showNewVersion && !error && (
          <>
            <p>Bạn cần tạo QR với số tiền ?</p>
            <div className={clsx(Styles.inputRow, Styles.amountRow)}>
              <input
                id="amount"
                name="amount"
                type="text"
                placeholder="Nhập số tiền"
                value={qrNormalAmount.formatValue}
                onChange={(e) => handleNormalAmountChange(e)}
                className={clsx(Styles.amountInput)}
              />
              <button type="button" onClick={handleGenerateNormalQR}>
                Tạo QR
              </button>
            </div>
          </>
        )}

        {error && <span className={clsx(Styles.errorMessage)}>{error}</span>}
        {!error && qrNormalError && (
          <span className={clsx(Styles.errorMessage)}>{qrNormalError}</span>
        )}
      </div>
    </div>
  );

  const renderFooter = () => (
    <div className={clsx(Styles.qrFooter)}>
      <div className={clsx(Styles.footerContent)}>
        <Button
          type="button"
          className={clsx(Styles.toggleButton)}
          onClick={() => handleChangeVersion(!showNewVersion)}
        >
          {showNewVersion ? "Tạo QR linh hoạt" : "Tạo QR với số tiền nhập"}
        </Button>
        <div className={clsx(Styles.messages)}>
          <p className={clsx(Styles.helpText)}>
            Đăng nhập lại và nhận KNB tại tiền trang Ba Lăng
            Huyện
          </p>
          <p className={clsx(Styles.note)}>
            Không đổi nội dung sau khi quét mã
          </p>
        </div>
        <button
          className={clsx(Styles.contactButton)}
          onClick={() => window.open(Path.SUPPORT, "_blank")}
        >
          <div className={clsx(Styles.buttonContent)}>
            <RiMessengerLine size={20} />
            <span>Liên hệ</span>
          </div>
        </button>
      </div>
    </div>
  );

  return (
    <div className={clsx(Styles.payment)}>
      <div className={clsx(Styles.qrHeader)}>
        <h2 className={clsx(Styles.title)}>
          Thêm Kim Nguyên Bảo tự động
        </h2>
      </div>

      <div className={clsx(Styles.qrCode)}>
        {/* Phần QR khuyến mãi */}
        <div className={clsx(Styles.qrCodeKm)}>
          {loading && renderLoadingState()}
          {!loading && error && renderErrorState()}
          {!error && !loading && qrCode && renderQRContent()}

          {renderInputForm()}

            <div className={clsx(Styles.noteContainer)}>
             <p className={clsx(Styles.note)}>
               Số KNB sau khi được tính theo tỉ lệ khuyến mãi sẽ được làm tròn xuống số nguyên gần nhất nếu lẻ thập phân.
             </p>
            <p className={clsx(Styles.note)}>
              Tích luỹ tính theo id đăng nhập và tính lại từ đầu mỗi khi đủ tổng
              2 mức tích luỹ trên
            </p>
          </div>
        </div>

        {/* Phần QR thêm thường */}
        {renderNormalQRSection()}
      </div>

      {/* Phần footer */}
      {renderFooter()}
    </div>
  );
};
// Component: User Information Section
const UserInfoSection = ({
  user,
  hasDeleteRequest,
  isSubmittingDelete,
  handleDeleteAccount,
}) => {
  const personalRows = [
    {
      label: "Họ và tên",
      value: user?.FullName || "*********",
    },
    {
      label: "Ngày sinh",
      value:
        formatProfileDay(user?.DateOfBirth) || "*********",
    },
    {
      label: "Số điện thoại",
      value: user?.Phone || "*********",
    },
  ];

  const accountRows = [
    {
      label: "Tài khoản",
      value: user?.AccountName || "*********",
    },
    {
      label: "Nhân vật",
      value: "*********",
    },
    {
      label: "Mật khẩu cấp 1",
      value: "*********",
    },
    {
      label: "Mật khẩu cấp 2",
      value: "*********",
    },
    {
      label: "KNB",
      value:
        user?.Knb !== undefined && user?.Knb !== null && user?.Knb !== ""
          ? formatNumber(user.Knb)
          : 0,
      isStrong: true,
    },
    {
      label: "KNB Khóa",
      value:
        user?.KnbKhoa !== undefined && user?.KnbKhoa !== null && user?.KnbKhoa !== ""
          ? formatNumber(user.KnbKhoa)
          : 0,
      isStrong: true,
    },
  ];
  const renderRows = (rows) =>
    rows.map((row) => (
      <div className={clsx(Styles.infoRow)} key={row.label}>
        <span className={clsx(Styles.infoLabel)}>{row.label}</span>
        <span
          className={clsx(Styles.infoValue, {
            [Styles.infoValueStrong]: row.isStrong,
          })}
        >
          {row.value}
        </span>
      </div>
    ));

  return (
    <div className={clsx(Styles.informationDetail)}>
      <div className={clsx(Styles.infoColumn)}>
        <div className={clsx(Styles.infoBlock)}>
          <h3>Thông tin cá nhân</h3>
          <div className={clsx(Styles.infoRows)}>{renderRows(personalRows)}</div>
        </div>
        <div className={clsx(Styles.infoBlock, Styles.deleteAccountBlock)}>
          <h3>Xóa tài khoản</h3>
          <p className={clsx(Styles.deleteAccountText)}>
            Xóa tất cả thông tin đăng nhập của bạn và các kênh đăng nhập
          </p>
          {hasDeleteRequest && (
            <p className={clsx(Styles.deleteAccountStatus)}>
              Yêu cầu xóa tài khoản đã được gửi. Vui lòng đợi xác nhận từ admin
            </p>
          )}
          <button
            type="button"
            className={clsx(Styles.deleteAccountButton)}
            onClick={handleDeleteAccount}
            disabled={hasDeleteRequest || isSubmittingDelete}
          >
            Xóa tài khoản
          </button>
        </div>
      </div>
      <div className={clsx(Styles.infoBlock)}>
        <h3>Thông tin tài khoản</h3>
        <div className={clsx(Styles.infoRows)}>{renderRows(accountRows)}</div>
      </div>
    </div>
  );
};

// Component: History Section
const HistorySection = ({
  voucherHistories,
  introducedHistories,
  totalBonus,
  columns,
}) => {
  return (
    <div className={clsx(Styles.informationExtra)}>
      {voucherHistories && voucherHistories.length > 0 && (
        <ClientHistoryModalTable
          title={"Lịch sử thêm:"}
          columns={columns.voucher}
          data={voucherHistories}
        />
      )}
      {/* {introducedHistories && introducedHistories.length > 0 && (
        <ClientHistoryModalTable
          title={"Lịch sử giới thiệu:"}
          total={totalBonus}
          columns={columns.introduced}
          data={introducedHistories}
        />
      )} */}
    </div>
  );
};

// Component: Modal Footer
const ModalFooter = ({ handleUpdate, handleChangePass, handleClose }) => {
  return (
    <Modal.Footer className={clsx(Styles.footer)}>
      <div className={clsx(Styles.information)}></div>
      <div className={clsx(Styles.groupAction)}>
        {/* <Button className={clsx(Styles.btnAction)} onClick={handleUpdate}> */}
        {/* <Button className={clsx(Styles.btnAction)} onClick={handleChangePass}> */}
      </div>
    </Modal.Footer>
  );
};

// Main Component: MDProfile
function ClientProfile({
  showProfile,
  handleClose,
  data,
  introduceId,
}) {
  const {
    loading,
    voucherText,
    user,
    qrCode,
    handleChangePass,
    handleUpdate,
    handleSubmit,
    voucherHistories,
    introducedHistories,
    error,
    handleGenerateDefaultQR,
    qrUserId,
    voucherHistoryColumns,
    introducedHistoryColumns,
    voucher,
    totalBonus,
    example,
    handleAmountChange,
    amount,
    showNewVersion,
    handleChangeVersion,
    handleNormalAmountChange,
    qrNormalAmount,
    qrNormal,
    handleGenerateNormalQR,
    qrNormalError,
    hasDeleteRequest,
    isSubmittingDelete,
    handleDeleteAccount,
  } = useMDProfile({ showProfile, data, introduceId });

  const [modalZIndex, setModalZIndex] = useState(2000);
  const refModal = useRef(null);
  const rafRef = useRef(null);
  const lastValueRef = useRef(2000);

  useEffect(() => {
    if (!showProfile || !refModal.current || !refModal.current.dialog) return;

    const dialogElement = refModal.current.dialog;

    const handleScroll = () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }

      rafRef.current = requestAnimationFrame(() => {
        const scrollPosition = dialogElement.scrollTop;
        const newZIndex = scrollPosition > 40 ? 200000 : 2000;

        // Only update if value changed
        if (newZIndex !== lastValueRef.current) {
          setModalZIndex(newZIndex);
          lastValueRef.current = newZIndex;
        }
      });
    };

    dialogElement.addEventListener("scroll", handleScroll);

    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      dialogElement.removeEventListener("scroll", handleScroll);
    };
  }, [showProfile]);

  return (
    <Modal
      style={{ backgroundColor: "none", zIndex: modalZIndex }}
      dialogClassName={clsx(Styles.modalDialog)}
      contentClassName={clsx(Styles.main)}
      show={showProfile}
      size="lg"
      centered
      backdrop={false}
      ref={refModal}
    >
      <Modal.Body className={clsx(Styles.bodyWrap)}>
        <div className={clsx(Styles.flexGrow)}>
          <div className={clsx(Styles.container)}>
            <QRCodeSection
              loading={loading}
              error={error}
              qrCode={qrCode}
              voucherText={voucherText}
              qrUserId={qrUserId}
              handleSubmit={handleSubmit}
              handleGenerateDefaultQR={handleGenerateDefaultQR}
              voucher={voucher}
              example={example}
              handleAmountChange={handleAmountChange}
              amount={amount}
              showNewVersion={showNewVersion}
              handleChangeVersion={handleChangeVersion}
              qrNormalAmount={qrNormalAmount}
              handleNormalAmountChange={handleNormalAmountChange}
              qrNormal={qrNormal}
              handleGenerateNormalQR={handleGenerateNormalQR}
              qrNormalError={qrNormalError}
            />
            <div className={clsx(Styles.information)}>
              <UserInfoSection
                user={user}
                hasDeleteRequest={hasDeleteRequest}
                isSubmittingDelete={isSubmittingDelete}
                handleDeleteAccount={handleDeleteAccount}
              />
              <HistorySection
                voucherHistories={voucherHistories}
                introducedHistories={introducedHistories}
                totalBonus={totalBonus}
                columns={{
                  voucher: voucherHistoryColumns,
                  introduced: introducedHistoryColumns,
                }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <ModalFooter
        handleUpdate={handleUpdate}
        handleChangePass={handleChangePass}
        handleClose={handleClose}
      />
    </Modal>
  );
}

export default ClientProfile;
